import {DataTable, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, Button} from '@carbon/react';
import React, {useState} from 'react';
import {ChevronDown} from '@carbon/icons-react'; 
import Tabs from '../components/tabs/tabs';
import {RadioButton} from '@carbon/react';

function MyFiles() {
    // Dummy data for now
    const rows = [
        {
            id: '1',
            fileName: 'File 1',
            dataValidation: 'Complete',
            lastUpdated: '2024-01-01',
        },
        {
            id: '2',
            fileName: 'File 2',
            dataValidation: 'Pending',
            lastUpdated: '2024-01-02',
        },
    ];

    const headers = [
        {key: 'expand', header: ''},
        {key: 'fileName', header: 'File Name'},
        {key: 'dataValidation', header: 'Data Validation'},
        {key: 'lastUpdated', header: 'Last Updated'},
        {key: 'actions', header: ''},
    ];

    const tabs = [
        {
            label: 'Provider/Facility Locations',
            content: <p></p>, 
        }
    ];

    const [expandedRowId, setExpandedRowId] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null); 

    const toggleExpand = (id: any) => {
        setExpandedRowId(expandedRowId === id ? null : id);
    };

    const handleRadioChange = (id: any) => {
        setSelectedRowId(id); 
    };

    return (
        <div className="my-files-page bg-white shadow-lg h-[calc(100vh-11rem+2px)] p-4 pl-12 w-full overflow-hidden">
            <div className="flex items-center justify-between bg-gray-100 p-4 rounded mb-4">
                <div className="flex flex-col justify-center">
                    <h3 className="text-xl font-bold m-0">My Files</h3>
                    <p className="text-sm text-gray-600 m-0">Choose to upload a new file or browse saved files</p>
                </div>
                <button className="bg-blue-500 text-white font-semibold py-2 px-4 rounded ml-auto">
                    Upload New File
                </button>
            </div>

            <div className="grid grid-cols-6 gap-4">
                <div className="col-span-6 bg-white shadow-lg rounded p-2">
                    <Tabs tabs={tabs} />

                    <div className="mt-4">
                        <div className="flex justify-end mb-2">
                            <Button kind="primary">Open File</Button>
                        </div>
                        <TableContainer>
                            <DataTable rows={rows} headers={headers}>
                                {({headers}) => (
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {headers.map(header => (
                                                    <TableHeader key={header.key}>
                                                        <div className="w-full text-left">{header.header}</div>
                                                    </TableHeader>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.map(row => (
                                                <React.Fragment key={row.id}>
                                                    <TableRow>
                                                        <TableCell>
                                                            <div className="flex items-center">
                                                                <RadioButton
                                                                    id={`radio-${row.id}`}
                                                                    name="file"
                                                                    labelText=""
                                                                    value={row.id}
                                                                    checked={selectedRowId === row.id} 
                                                                    onChange={() => handleRadioChange(row.id)} 
                                                                />
                                                                <button onClick={() => toggleExpand(row.id)} className="ml-2 flex items-center">
                                                                    <ChevronDown className={`transform transition-transform ${expandedRowId === row.id ? 'rotate-180' : ''}`} />
                                                                </button>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell>{row.fileName}</TableCell>
                                                        <TableCell>{row.dataValidation}</TableCell>
                                                        <TableCell>{row.lastUpdated}</TableCell>
                                                        <TableCell>
                                                            <button className="text-blue-500">Edit/Delete</button>
                                                        </TableCell>
                                                    </TableRow>
                                                    {expandedRowId === row.id && (
                                                        <TableRow>
                                                            <TableCell colSpan={5} className="bg-gray-100">
                                                                <p>Details for {row.fileName}</p>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                            </DataTable>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MyFiles;
